import type { ParseKeys } from 'i18next';
import { UserRole } from '../constants/enums';

export interface NavItemConfig {
    id: string;
    /** i18n key for the label */
    labelKey: ParseKeys<'translation'>;
    link: string;
    /**
     * Roles that may see this item.
     * Empty array means the item is visible to ALL roles (including guests).
     */
    allowedRoles: UserRole[];
}

const ALL_ROLES: UserRole[] = [];

// const USER_AND_ABOVE: UserRole[] = [
//     UserRole.User,
//     UserRole.CompanyAdministrator,
//     UserRole.CompanyOwner,
//     UserRole.Admin,
//     UserRole.Superadmin,
// ];

// const COMPANY_ADMIN_AND_ABOVE: UserRole[] = [
//     UserRole.CompanyAdministrator,
//     UserRole.CompanyOwner,
//     UserRole.Admin,
//     UserRole.Superadmin,
// ];

const navItems: NavItemConfig[] = [
    { id: 'home', labelKey: 'menu.home', link: '/', allowedRoles: ALL_ROLES },
    { id: 'dashboard', labelKey: 'menu.dashboard', link: '/dashboard', allowedRoles: ALL_ROLES },
    { id: 'companies', labelKey: 'menu.companies', link: '/companies', allowedRoles: ALL_ROLES },
    { id: 'codebooks', labelKey: 'menu.codebooks', link: '/codebooks', allowedRoles: ALL_ROLES },
    { id: 'analytics', labelKey: 'menu.analytics', link: '/analytics', allowedRoles: ALL_ROLES },
    { id: 'settings', labelKey: 'menu.settings', link: '/settings', allowedRoles: ALL_ROLES },
    { id: 'help', labelKey: 'menu.help', link: '/help', allowedRoles: ALL_ROLES },
    { id: 'about', labelKey: 'menu.about', link: '/about', allowedRoles: ALL_ROLES },
];

export default navItems;
